import { InputProps, SelectInput } from "react-admin"

import { BillStatusChoices } from "../../billing_constants"

export const BillStatusSelectInput: React.FC<InputProps> = (props) => (
  <SelectInput {...props} choices={BillStatusChoices} />
)
